"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
exports.default = `<svg id="machine-icon-machinetool" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 540 540">
  <path fill="gray" d="M220 332v208l247-142V190z" />
  <path fill="#CCC" d="M320 105l147 84-247 142-146-85z" />
  <path fill="gray" d="M74 246l146 85v209L74 455z" />
  <path fill="none" stroke="#B7B7B7" stroke-linecap="round" stroke-miterlimit="10" stroke-width="12"
    d="M487 289v96c0 21-12 32-26 25l-25-14" />
  <path fill="#B7B7B7" d="M220 296v210l247-142V155z" />
  <path fill="#E6E6E6" d="M320 70l147 85-247 141-146-84z" />
  <path fill="#D8D8D8" d="M74 212l146 84v210L74 421z" />
  <path fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"
    d="M104 416c-6-4-11-12-11-18V258c0-7 5-9 11-6l86 50c6 3 11 11 11 18v139c0 7-5 10-11 7l-86-50z" />
  <path fill="#4D4D4D" d="M284 260v209l120-69V191z" />
  <path fill="#999" d="M300 335v100l87-50z" />
  <path d="M300 283v152l87-50V233z" />
  <path fill="#4D4D4D" d="M139 174l145 86 120-69-145-86z" />
  <path fill="none" stroke="#1A1A1A" stroke-linecap="round" stroke-miterlimit="10" stroke-width="7"
    d="M396 283l8 5c5 3 8 9 8 14v48c0 6-3 8-8 5l-8-5" />
  <path fill="#666" d="M450 282l21 75 54-31-21-76z" />
  <path fill="#333" d="M458 285l5 19 42-25-5-19z" />
  <path fill="gray" d="M495 246l9 4-54 32-9-5z" />
  <path fill="#4D4D4D" d="M471 357l-9-5-21-75 9 5z" />
  <path fill="#FCEE21" d="M477 329c-4 1-5 7-4 11s5 6 8 4 5-7 4-11c-1-5-5-6-8-4z" />
  <path fill="red" d="M479 331c-2 1-3 5-2 7s3 5 5 3 4-5 3-7c-1-3-3-5-6-3z" />
  <path fill="#999"
    d="M464 306v1l1 5 1 1 11-6 1-2-1-5-2-1-11 7zM479 297v2l1 5h1l11-6 1-1-2-6h-1l-11 6zM494 288l-1 2 2 5 1 1 11-7v-1l-1-5-1-1-11 6zM467 316v1l1 5 1 1 11-6 1-2-2-5-1-1-11 7zM482 307l-1 1 2 6h1l11-6 1-2-2-5h-1l-11 6zM497 298l-1 2 2 5 1 1 11-7v-1l-1-6h-1l-11 6zM485 317l-1 1 2 6h1l11-6v-2l-1-5h-1l-11 6zM500 308l-1 2 2 5 1 1 11-7v-1l-1-5-1-1-11 6zM488 327l-1 1 2 5 1 1 11-6v-2l-1-5-1-1-11 7z" />
  <path fill="#5BC571" d="M503 318l-1 2 1 5h1l12-6v-1l-1-6h-1l-11 6z" />
  <path fill="gray"
    d="M99 264c0-2 2-3 3-2 2 1 3 3 3 5s-1 3-3 2l-3-5zM189 315c0-2 1-3 3-2 1 1 3 3 3 5s-2 3-3 2c-2-1-3-3-3-5zM99 399c0-2 2-2 3-2 2 1 3 4 3 6s-1 2-3 1c-1-1-3-3-3-5zM189 450c0-2 1-2 3-1 1 1 3 3 3 5s-2 2-3 2l-3-6z" />
  <path fill="#1A1A1A"
    d="M373 157l23-14V99c0-31-25-70-56-88-19-11-38-13-52-5-5 3-10 8-13 13 11-1 23 2 35 9 32 18 57 57 57 89v36" />
  <path d="M269 99V43c0-9 2-18 6-24 8-1 16 0 24 4v59l-30 17z" />
  <path
    d="M361 75l25-14-1-3-24 14v3zM358 24l-24 14v3l26-15-2-2zM355 65l25-14-1-2-24 13v3zM348 16l-24 14v3l26-15-2-2zM306 1l-23 14v3l28-16-5-1zM349 56l25-14-2-2-24 13 1 3zM324 4l-22 13v3l25-15-3-1zM337 9l-23 14v3l26-15-3-2zM373 147l23-14v-3l-23 14zM373 133l23-13v-3l-23 13zM373 120l23-13v-3l-23 13zM390 69l-24 13v3l24-14v-2zM342 49l26-15-2-2-24 14v3zM393 80l-23 13v3l24-14-1-2zM396 91l-24 14v3l24-14v-3z" />
  <path fill="#333"
    d="M275 19c-4 6-6 15-6 24v56l6-4V39v-3s3-22 24-13l11 5c32 18 57 57 57 88v37l6 3v-43c0-31-25-70-57-88 1 0-27-19-41-6z" />
  <path fill="#B7B7B7" d="M268 149v64l55-31v-64z" />
  <path fill="#D8D8D8" d="M170 157l98 56v-94L123 37v147z" />
  <path fill="#E6E6E6" d="M177 5l111 63-55 32-110-63z" />
  <path fill="#CCC" d="M233 100l35 49 55-31-35-50z" />
  <path fill="#999" d="M326 295v26l3 2 4-2v-29l-7 3z" />
  <path fill="#666" d="M323 271v43c0 2 3 3 6 3s6-1 6-3v-48l-12 5z" />
  <path fill="#929497" d="M310 277v11c0 5 9 9 19 9s20-4 20-9v-33l-39 22z" />
  <path fill="none" d="M367 153l6 4" />
</svg>`;
//# sourceMappingURL=machine-icon-machinetool.js.map